module.exports = __webpack_public_path__ + "static/img/oppo4.d2647d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/oppo/oppo4.png
// module id = 4LJD
// module chunks = 0